import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomeV4.vue'
import Node from '../views/NodeV4.vue'
import Xcbf from '../views/Home/Xcbf.vue'
import Ycdy from '../views/Home/Ycdy.vue'
import Devices from '../views/Devices.vue'
import Tools from '../views/Tools.vue'
import Help from '../views/Help.vue'
import Answer from '../views/Answer.vue'
import VipHome from '../views/VipHome.vue'
import VipAbout from '../views/VipAbout.vue'
import VipSearch from '../views/VipSearch.vue'
import Search from '../views/Home/Search.vue'
import Mapping from '../views/Home/Mapping.vue'
import VipMapping from '../views/VipMapping.vue'
import About from '../views/About.vue'
import Speed from '../views/Speed.vue'
import SpeedTelescope from '../views/SpeedTelescope.vue'
import SpeedShare from '../views/SpeedShare.vue'
import SpeedTabs from '../views/SpeedTabs.vue'
import Login from '../views/Login.vue'
import Mall from '../views/Mall.vue'
import MallRecord from '../views/MallRecord.vue'
import UserInfo from '../views/UserInfo.vue'
import BecomeVip from '../views/BecomeVip.vue'
import NodeManage from '../components/NodeManage.vue'
import Desc from '../views/Desc.vue'
import Download from '../views/Download.vue'
import Applications from '../views/Applications.vue'
import Kdts from '../views/Kdts.vue'
import ImageBackup from '../views/ImageBackup.vue'
import ImageBackupHelp from '../views/ImageBackupHelp.vue'
import VideoBackup from '../views/VideoBackup.vue'
import VideoBackupHelp from '../views/VideoBackupHelp.vue'
import DeviceSetting from '../views/DeviceSetting.vue'
import Wakeup from '../views/Wakeup.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		meta: {
			title: '节点小宝'
		},
		children: [
			{
				path: '/',
				redirect: 'xcbf'
			},
			{
				path: 'xcbf',
				component: Xcbf,
				name: 'Xcbf',
				meta: {
					title: 'Xcbf',
					isShowNav: true,
					navType: "xcbf"
				},
			},
			{
				path: 'ycdy',
				component: Ycdy,
				name: 'Ycdy',
				meta: {
					title: 'Ycdy',
					isShowNav: true,
					navType: "ycdy"
				},
			},
			{
				path: 'node',
				component: Node,
				name: 'Node',
				meta: {
					title: 'node',
					isShowNav: true,
					navType: "nwct"
				},
			},
			{
				path: 'search',
				component: Search,
				name: 'Search',
				meta: {
					title: 'search',
					isShowNav: true,
					navType: "nwct"
				},
			},
			{
				path: 'mapping',
				component: Mapping,
				name: 'Mapping',
				meta: {
					title: 'Mapping',
					isShowNav: true,
					navType: "nwct"
				},
			},
			{
				path: 'help',
				component: Help,
				name: 'Help',
				meta: {
					title: 'Help'
				},
			},
			{
				path: 'answer',
				component: Answer,
				name: 'Answer',
				meta: {
					title: 'Answer'
				},
			},
			{
				path: 'devices',
				component: Devices,
				name: 'Devices',
				meta: {
					title: 'Devices'
				},
			},
			{
				path: 'tools',
				component: Tools,
				name: 'Tools',
				meta: {
					title: 'Tools'
				},
			},
			{
				path: 'viphome',
				component: VipHome,
				name: 'VipHome',
				meta: {
					title: 'VipHome'
				},
			},
			{
				path: 'vipabout',
				component: VipAbout,
				name: 'VipAbout',
				meta: {
					title: 'VipAbout'
				},
			},
			{
				path: 'vipmapping',
				component: VipMapping,
				name: 'VipMapping',
				meta: {
					title: 'VipMapping'
				},
			},
			{
				path: 'vipsearch',
				component: VipSearch,
				name: 'VipSearch',
				meta: {
					title: 'VipSearch'
				},
			},
			{
				path: 'download',
				component: Download,
				name: 'Download',
				meta: {
					title: 'download'
				},
			},
			{
				path: 'mall',
				component: Mall,
				name: 'Mall',
				meta: {
					title: 'mall'
				},
			},
			{
				path: 'mall/record',
				component: MallRecord,
				name: 'MallRecord',
				meta: {
					title: 'MallRecord'
				},
			},
			{
				path: 'setting',
				component: About,
				name: 'Setting',
				meta: {
					title: 'setting'
				},
			},
			{
				path: 'about',
				component: About,
				name: 'About',
				meta: {
					title: 'about'
				},
			},
			{
				path: 'desc',
				component: Desc,
				name: 'Desc',
				meta: {
					title: 'desc'
				},
			},
			{
				path: 'speed',
				component: Speed,
				name: 'Speed',
				meta: {
					title: 'speed'
				},
			},
			{
				path: 'speedtelescope',
				component: SpeedTelescope,
				name: 'SpeedTelescope',
				meta: {
					title: 'speedtelescope'
				},
			},
			{
				path: 'speedshare',
				component: SpeedShare,
				name: 'SpeedShare',
				meta: {
					title: 'speedshare'
				},
			},
			{
				path: 'applications',
				component: Applications,
				name: 'applications',
				meta: {
					title: 'applications'
				},
			},
			{
				path: 'speedtabs',
				component: SpeedTabs,
				name: 'SpeedTabs',
				meta: {
					title: 'speedtabs'
				},
			},
			{
				path: 'userinfo',
				component: UserInfo,
				name: 'UserInfo',
				meta: {
					title: 'userinfo'
				},
			},
			{
				path: 'vip',
				component: BecomeVip,
				name: 'BecomeVip',
				meta: {
					title: 'becomevip'
				},
			},
			{
				path: 'kdts',
				component: Kdts,
				name: 'Kdts',
				meta: {
					title: 'kdts'
				},
			},
			{
				path: 'node/manage',
				component: NodeManage,
				name: 'NodeManage',
				meta: {
					title: 'NodeManage'
				},
			},
			{
				path: 'device/setting',
				component: DeviceSetting,
				name: 'DeviceSetting',
				meta: {
					title: 'DeviceSetting'
				},
			},
			{
				path: 'imagebackup',
				component: ImageBackup,
				name: 'ImageBackup',
				meta: {
					title: 'ImageBackup'
				},
			},
			{
				path: 'imagebackuphelp',
				component: ImageBackupHelp,
				name: 'ImageBackupHelp',
				meta: {
					title: 'ImageBackupHelp'
				},
			},
			{
				path: 'videobackup',
				component: VideoBackup,
				name: 'VideoBackup',
				meta: {
					title: 'VideoBackup'
				},
			},
			{
				path: 'videobackuphelp',
				component: VideoBackupHelp,
				name: 'VideoBackupHelp',
				meta: {
					title: 'VideoBackupHelp'
				},
			},
			{
				path: 'wakeup',
				component: Wakeup,
				name: 'Wakeup',
				meta: {
					title: 'Wakeup'
				},
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			title: 'Login'
		},
	},
]

function getBase() {
	let url = window.location.href.replace("//", "");
	let urls = url.split("/");
	let rurl = "/";
	if (urls.length > 1 && urls[1]) {
		for (let index = 1; index < 2; index++) {
			const url = urls[index];
			rurl += (url + "/")
		}
	}
	return rurl;
}

const router = new VueRouter({
	mode: 'history',
	base: process.env.NODE_ENV === 'production' ? getBase() : process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	next();
	return;
	//document.title = `${to.meta.title} | jdxb`;
	const owcode = localStorage.getItem('jdxb-owcode');
	// console.log(to, from)
	//用户即使刷新页面还是需要去绑定手机号
	let localStorageLoginBindFlag = localStorage.getItem("jdxb-login-bind-flag"); //1需要去绑定
	if (localStorageLoginBindFlag == '1') {//用户已扫码登录，但是没有绑定手机号，所以强制去登录页面绑定手机号
		if (to.path == '/login') {
			next();
		} else {
			next({ path: '/login', query: to.query });
		}
	} else if (!owcode && to.path == '/login') { //扫码跳转回来走这个逻辑
		next();
	} else if (!owcode && to.path !== '/login') { //未登录时走这个逻辑
		next({ path: '/login', query: to.query });
	} else if (owcode && to.path == '/login') { //已登录去home页
		next('/');
	} else {
		next();
	}
});

export default router
